import { Card } from "react-bootstrap";
import styled from "styled-components";

export const FileCard = styled(Card)`
  display: flex;
  align-items: center;
`;

export const MainCard = styled(Card)`
  margin: 32px 0;
`